module.exports = __webpack_public_path__ + "static/media/icon_balloon.13b72303.svg";